import { Menu, Moon, Sun, UserCircle2 } from 'lucide-react';
import { Link } from 'react-router';
import { cn } from '../lib/cn';
import { useTheme } from './useTheme';
import { ScopeSwitcher } from '../features/session/ScopeSwitcher';
import { RecognitionDayIndicator } from '../features/session/RecognitionDayIndicator';

export interface TopbarProps {
  onOpenMobile: () => void;
}

export function Topbar({ onOpenMobile }: TopbarProps) {
  const { resolved, toggle } = useTheme();

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex h-16 items-center gap-3 border-b border-gray-200 bg-white/90 px-4 backdrop-blur lg:px-6',
        'dark:border-gray-800 dark:bg-gray-950/90',
      )}
    >
      <button
        type="button"
        onClick={onOpenMobile}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-900 md:hidden dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
        aria-label="Open navigation"
      >
        <Menu className="h-5 w-5" aria-hidden="true" />
      </button>

      <div className="ml-auto flex items-center gap-2">
        <ScopeSwitcher />
        <RecognitionDayIndicator />
        <button
          type="button"
          onClick={toggle}
          className="inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-500 transition hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
          aria-label={
            resolved === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'
          }
          title={resolved === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          {resolved === 'dark' ? (
            <Sun className="h-5 w-5" aria-hidden="true" />
          ) : (
            <Moon className="h-5 w-5" aria-hidden="true" />
          )}
        </button>

        <Link
          to="/profile"
          className="inline-flex h-9 items-center gap-2 rounded-md px-2.5 text-sm text-gray-600 transition hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white"
          aria-label="Your profile"
        >
          <UserCircle2 className="h-6 w-6" aria-hidden="true" />
          <span className="hidden sm:inline">Profile</span>
        </Link>
      </div>
    </header>
  );
}
